<div class="users-container">
  <div class="bpx-toolbar">
    <div class="bpx-toolbar__actions">
      <button type="button" class="bpx-btn bpx-btn--primary" (click)="openAddUserDialog()">Add User</button>
      <button type="button" class="bpx-btn" (click)="openEditUserDialog()" [disabled]="!selectedUser">Edit User</button>
      <button
        type="button"
        class="bpx-btn bpx-btn--danger"
        (click)="confirmDelete()"
        [disabled]="!selectedUser || isSelfSelected()">
        Delete User
      </button>
    </div>
  </div>

  <section class="bpx-section users-section">
    <div class="bpx-section__head">
      <h3 class="bpx-section__title">Active Users</h3>
      <span class="bpx-section__count">
        {{ dataSource.data.length }} {{ dataSource.data.length === 1 ? 'user' : 'users' }}
      </span>
    </div>

    <div class="users-table bpx-table">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z0">
        <ng-container matColumnDef="first_name">
          <th mat-header-cell *matHeaderCellDef>First Name</th>
          <td mat-cell *matCellDef="let element">{{ element.first_name }}</td>
        </ng-container>

        <ng-container matColumnDef="last_name">
          <th mat-header-cell *matHeaderCellDef>Last Name</th>
          <td mat-cell *matCellDef="let element">{{ element.last_name }}</td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>Email</th>
          <td mat-cell *matCellDef="let element">{{ element.email }}</td>
        </ng-container>

        <ng-container matColumnDef="job_title">
          <th mat-header-cell *matHeaderCellDef>Job Title</th>
          <td mat-cell *matCellDef="let element">{{ element.job_title }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"
            class="user-row"
            [class.user-row-selected]="isSelected(row)"
            (click)="selectUser(row)"></tr>
      </table>

      @if (!dataSource.data.length) {
      <p class="bpx-empty">No active users.</p>
      }
    </div>
  </section>
</div>
